<template>
  <section>
    <Navbar :data="data" />
    <section class="intro app-container">
      <div class="intro__content">
        <img
          class="intro__content--hero"
          :src="
            require(`../assets/images/${data.intro.hero}${
              $isMobile() ? '-mobile' : ''
            }.png`)
          "
          :alt="data.intro.hero"
          data-aos="fade-up"
        />
        <h1 class="intro__content--title" data-aos="fade-up">
          {{ data.intro.title }}
        </h1>
        <h3 class="intro__content--subtitle" data-aos="fade-up">
          {{ data.intro.subtitle }}
        </h3>
        <p class="intro__content--body" data-aos="fade-right">
          {{ data.intro.body }}
        </p>
      </div>
    </section>
    <section class="favourites app-container">
      <div class="favourites__content">
        <img
          data-aos="zoom-in"
          class="favourites__content--food"
          :src="require(`../assets/images/${data.favourites.image}.png`)"
          :alt="data.favourites.image"
        />
        <h1 class="favourites__content--title" data-aos="fade-up">
          {{ data.favourites.title }}
        </h1>
        <h3 class="favourites__content--subtitle" data-aos="fade-up">
          {{ data.favourites.subtitle }}
        </h3>
        <p class="favourites__content--body" data-aos="fade-right">
          {{ data.favourites.body_1 }}
        </p>
        <p class="favourites__content--body" data-aos="fade-right">
          {{ data.favourites.body_2 }}
        </p>
        <div class="favourites__content--facts">
          <img
            class="woman left"
            src="../assets/images/woman.png"
            data-aos="fade-right"
            alt="woman-eating"
          />
          <food-carousel
            class="right"
            :items="data.favourites.food_items"
            data-aos="fade-left"
          />
        </div>
        <div class="favourites__content--vegetarian">
          <div class="left">
            <h3 data-aos="fade-up">{{ data.favourites.vegetarian.title }}</h3>
            <p data-aos="fade-up">{{ data.favourites.vegetarian.body_1 }}</p>
            <h4 data-aos="fade-right">
              {{ data.favourites.vegetarian.body_2 }}
            </h4>
          </div>
          <img
            class="right"
            src="../assets/images/mezze.png"
            data-aos="zoom-in"
            alt="mezze"
          />
        </div>
      </div>
    </section>
    <section class="vegetarian app-container">
      <h4 class="vegetarian__title" data-aos="fade-up">
        {{ data.vegetarian.vegetarian_favourites.title }}
      </h4>
      <podium
        :data="data.vegetarian.vegetarian_favourites.dishes"
        data-aos="zoom-in"
      />
      <div class="vegetarian__vegan">
        <h4 class="vegetarian__vegan--title" data-aos="fade-up">
          {{ data.vegetarian.vegan_favourites.title }}
        </h4>
        <div class="vegetarian__vegan--stats">
          <ul class="left">
            <li
              v-for="(dish, i) in data.vegetarian.vegan_favourites.dishes"
              :key="`dish_${i}`"
              data-aos="fade-right"
            >
              <p>
                <span>{{ i + 1 }}. </span> {{ dish }}
              </p>
            </li>
          </ul>
          <img
            class="right"
            :src="
              require(`../assets/images/${data.vegetarian.vegan_favourites.image}.png`)
            "
            data-aos="fade-left"
            :alt="data.vegetarian.vegan_favourites.image"
          />
        </div>
      </div>
    </section>
    <section class="cuisines">
      <h3 class="cuisines__title" data-aos="fade-up">
        {{ data.cuisines.title }}
      </h3>
      <p class="cuisines__subtitle" data-aos="fade-up">
        {{ data.cuisines.subtitle }}
      </p>
      <div class="cuisines__arrows">
        <div class="cuisines__arrows--main">
          <titled-list
            :style="
              data.cuisines.dish.list.length > 0 && !$isMobile()
                ? 'width: 40%;'
                : 'width: 80%;'
            "
            data-aos="fade-right"
            class="list"
            :list="data.cuisines.country.list"
            :title="data.cuisines.country.title"
          />
          <titled-list
            data-aos="fade-right"
            class="list"
            v-if="$isMobile() && data.cuisines.dish.list.length > 0"
            :title-first="false"
            :list="data.cuisines.dish.list"
            :title="data.cuisines.dish.title"
          />
          <titled-list
            data-aos="fade-right"
            class="list"
            v-if="!$isMobile() && data.cuisines.dish.list.length > 0"
            :list="data.cuisines.dish.list"
            :title="data.cuisines.dish.title"
          />
          <img
            data-aos="zoom-in"
            class="wrap"
            :src="require(`../assets/images/${data.cuisines.image}.png`)"
            :alt="data.cuisines.image"
          />
        </div>
        <div class="cuisines__arrows--end"></div>
      </div>
    </section>
    <section class="cities">
      <div class="cities__box">
        <h4 class="cities__box--title" data-aos="fade-up">
          {{ data.cities.title }}
        </h4>
        <p class="cities__box--subtitle" data-aos="fade-up">
          {{ data.cities.subtitle }}
        </p>
        <ul class="cities__box--list">
          <li
            v-for="(city, i) in data.cities.list"
            :key="`city_${i}`"
            data-aos="fade-right"
          >
            <p>
              <span v-if="locality !== 'it'">{{ i + 1 }}. </span> {{ city }}
            </p>
          </li>
        </ul>
      </div>
      <img
        class="cities__building"
        src="../assets/images/building.png"
        alt="building"
      />
    </section>
    <section class="map app-container">
      <div class="map__title left">
        <h1 data-aos="fade-up">{{ data.maps.title }}</h1>
        <h3 data-aos="fade-up">{{ data.maps.subtitle }}</h3>
        <p>{{ data.maps.body_1 }}</p>
        <p>{{ data.maps.body_2 }}</p>
      </div>
      <country-map
        :data="data.maps"
        data-aos="zoom-in"
        class="map__component"
      />
    </section>
    <section class="outro app-container">
      <img
        class="outro__image"
        :src="require(`../assets/images/${data.outro.image}.png`)"
        :alt="data.outro.image"
        data-aos="fade-up"
      />
      <h1 class="outro__title" data-aos="fade-up">{{ data.outro.title }}</h1>
      <p class="outro__body" data-aos="fade-up">{{ data.outro.body }}</p>
      <a class="outro__button" :href="data.download" target="_blank">
        <img
          class="outro__button--image"
          src="../assets/images/download-black.svg"
          alt="download"
        />{{ data.outro.button }}
      </a>
    </section>
    <section class="footer">
      <h2 data-aos="fade-up">{{ data.footer.title }}</h2>
      <div class="footer__contacts">
        <ul
          v-for="(contact, i) in data.footer.contacts"
          :key="`contact_${i}`"
          data-aos="fade-right"
        >
          <li>
            <strong>{{ contact.company }}</strong>
          </li>
          <li>{{ contact.name }}</li>
          <li>{{ contact.email }}</li>
          <li>{{ contact.number }}</li>
          <li>{{ contact.address }}</li>
        </ul>
        <img
          :src="require(`../assets/images/${data.navbar.logo}.png`)"
          :alt="data.navbar.logo"
        />
      </div>
    </section>
  </section>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import FoodCarousel from '../components/FoodCarousel.vue'
import Podium from '../components/Podium.vue'
import TitledList from '../components/TitledList.vue'
import CountryMap from '../components/CountryMap.vue'

export default {
  name: 'FoodTrends',
  components: {
    Navbar,
    FoodCarousel,
    Podium,
    TitledList,
    CountryMap,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
      required: true,
    },
    locality: {
      type: String,
      default: '',
      required: true,
    },
  },
}
</script>

<style lang="scss">
$desktop: 1440px;
$tablet: 768px;
$mobile: 600px;

.app-container {
  padding: 20px 5%;
  position: relative;
}
.left {
  padding-left: 6%;
  padding-right: 2%;
  width: 42%;
  @media (max-width: $tablet) {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}
.right {
  padding-right: 6%;
  padding-left: 2%;
  width: 42%;
  @media (max-width: $tablet) {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}
.intro {
  background-color: var(--color-orange-1);
  z-index: 0;
  clip-path: polygon(0 0, 100% 0, 100% 70%, 0 100%);
  &__content {
    padding-bottom: 200px;
    &--hero {
      width: 100%;
    }
    &--title,
    &--subtitle,
    &--body {
      color: var(--color-white-1);
      width: 100%;
    }
    &--title,
    &--subtitle {
      margin-bottom: 10px;
      padding: 0 2%;
      @media (max-width: $tablet) {
        padding: 0;
        margin-bottom: 20px;
      }
    }
    &--subtitle {
      margin-top: 10px;
    }
    &--body {
      width: 40%;
      padding: 6%;
      @media (max-width: $tablet) {
        width: 90%;
        padding: 6% 2% 20%;
      }
    }
  }
}
.favourites {
  z-index: 1;
  margin-top: -300px;
  &__content {
    padding-bottom: 300px;
    @media (max-width: $tablet) {
      padding-bottom: 150px;
    }
    &--food {
      padding: 0 4%;
      width: 50%;
      @media (max-width: $tablet) {
        width: 90%;
        padding: 50px 4%;
      }
    }
    &--title,
    &--subtitle,
    &--body {
      color: var(--color-charcoal-1);
    }
    &--title,
    &--subtitle {
      margin: 10px 0;
      @media (max-width: $tablet) {
        margin-bottom: 20px;
      }
    }
    &--title,
    &--subtitle {
      width: 100%;
      padding: 0 6%;
      @media (max-width: $tablet) {
        padding: 0;
        margin-bottom: 20px;
      }
    }
    &--body {
      width: 42%;
      padding: 0 6%;
      font-size: 22px;
      margin-bottom: 40px;
      @media (max-width: $tablet) {
        width: 100%;
        padding: 0;
        font-size: 18px;
      }
      @media (max-width: $desktop) {
        font-size: 20px;
      }
    }
    &--facts {
      display: flex;
      margin-top: 100px;
      align-items: center;
      justify-content: space-around;
      @media (max-width: $tablet) {
        flex-direction: column;
        margin-bottom: 100px;
        .woman {
          margin-bottom: 100px;
        }
      }
    }
    &--vegetarian {
      display: flex;
      margin-top: 50px;
      align-items: center;
      justify-content: space-around;
      @media (max-width: $tablet) {
        flex-direction: column;
        margin-top: -80px;
      }
      h3 {
        margin: 10px 0;
      }
      p {
        margin: 20px 0;
      }
      h4 {
        font-size: 50px;
        line-height: 45px;
        margin: 10px 0;
        color: var(--color-orange-1);
        @media (max-width: $tablet) {
          font-size: 18px;
        }
        @media (max-width: $desktop) {
          font-size: 20px;
        }
      }
      h3,
      p,
      h4,
      img {
        @media (max-width: $tablet) {
          margin: 30px 0;
        }
      }
    }
  }
}
.vegetarian {
  background-color: var(--color-mozzarella-3);
  clip-path: polygon(0 0, 100% 30%, 100% 100%, 0 100%);
  z-index: 0;
  margin-top: -750px;
  padding-top: 400px;
  @media (max-width: $tablet) {
    margin-top: -550px;
  }
  &__title {
    padding: 0 6%;
    @media (max-width: $tablet) {
      padding: 0;
    }
  }
  &__vegan {
    padding: 150px 8% 100px;
    @media (max-width: $tablet) {
      padding: 0;
    }
    &--stats {
      background-color: var(--color-mozzarella-4);
      border-radius: 30px;
      display: flex;
      height: 250px;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      -webkit-box-align: start;
      -ms-flex-align: start;
      align-items: center;
      justify-content: flex-end;
      @media (max-width: $tablet) {
        flex-direction: column;
        height: 300px;
        padding: 20px;
      }
      ul {
        list-style-type: none;
        padding: 0 20px;
        @media (max-width: $tablet) {
          padding: 20px 0;
        }
        p {
          font-size: 22px;
          padding: 20px 0 0 20px;
          margin: 0;
          font-weight: 600;
          @media (max-width: $tablet) {
            padding: 0 0 0 20px;
            font-size: 18px;
          }
          @media (max-width: $desktop) {
            font-size: 20px;
          }
          span {
            font-size: 22px;
            margin-right: 10px;
            color: var(--color-orange-1);
            @media (max-width: $tablet) {
              font-size: 18px;
            }
            @media (max-width: $desktop) {
              font-size: 20px;
            }
          }
        }
      }
      img {
        margin-top: -20px;
      }
    }
  }
}
.cuisines {
  background-color: var(--color-mozzarella-3);
  margin-top: -50px;
  padding: 0;
  &__title,
  &__subtitle {
    padding: 0 8%;
    @media (max-width: $tablet) {
      padding: 10px 5%;
    }
  }
  &__title {
    padding-top: 100px;
    margin: 20px 0;
    @media (max-width: $tablet) {
      margin: 0;
    }
  }
  &__subtitle {
    margin: 10px 0;
    @media (max-width: $tablet) {
      margin: 0;
    }
  }
  &__arrows {
    display: flex;
    @media (max-width: $tablet) {
      flex-direction: column;
      margin-top: 50px;
    }
    &--main {
      margin-top: 50px;
      background-color: var(--color-grey-1);
      width: 90%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      z-index: 1;
      height: 300px;
      @media (max-width: $tablet) {
        background-color: var(--color-cupcake-1);
        order: 2;
        width: 90%;
        margin: 0 5%;
        height: 1000px;
        flex-direction: column;
      }
      .wrap {
        width: 25%;
        @media (max-width: $tablet) {
          width: 100%;
        }
      }
      .list {
        @media (max-width: $tablet) {
          width: 100%;
        }
      }
    }
    &--end {
      margin-top: 50px;
      clip-path: polygon(0 0, 0% 100%, 100% 50%);
      background-color: var(--color-grey-1);
      width: 10%;
      z-index: 0;
      height: 300px;
      @media (max-width: $tablet) {
        background-color: var(--color-cupcake-1);
        order: 1;
        clip-path: polygon(50% 0%, 0 30%, 100% 30%);
        width: 90%;
        margin: 0 5% -212px;
      }
    }
  }
}
.cities {
  background-color: var(--color-mozzarella-3);
  padding: 100px 0;
  @media (max-width: $tablet) {
    padding-top: 10px;
  }
  &__box {
    background-color: var(--color-orange-1);
    color: var(--color-white-1);
    border-radius: 30px;
    padding: 20px;
    width: 50%;
    margin: 50px 25%;
    z-index: 1;
    position: relative;
    @media (max-width: $tablet) {
      margin: 150px 5% 100px;
      width: 90%;
      padding: 20px 0;
    }
    &--title,
    &--subtitle {
      padding: 0 4%;
    }
    &--title {
      margin: 10px 0;
    }
    &--subtitle {
      margin: 0 0 20px;
    }
    &--list {
      list-style: none;
      column-count: 2;
      column-gap: 30px;
      padding: 0 10% 0 20%;
      @media (max-width: $tablet) {
        padding: 0 10%;
        width: 90%;
      }
      li {
        display: inline-block;
        width: 100%;
        p {
          span {
            font-weight: 600;
            font-size: 22px;
            margin-right: 10px;
            @media (max-width: $tablet) {
              font-size: 18px;
            }
            @media (max-width: $desktop) {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
  &__building {
    width: 100%;
    margin-top: -300px;
    z-index: 0;
    @media (max-width: $tablet) {
      width: 200%;
    }
  }
}
.map {
  background-color: var(--color-mozzarella-1);
  padding-bottom: 200px;
  &__title {
    margin-top: -100px;
    width: 50%;
    @media (max-width: $tablet) {
      width: 100%;
    }
    h1,
    p {
      margin: 20px 0;
    }
  }
  &__badge {
    width: 30%;
    @media (max-width: $tablet) {
      display: none;
    }
  }
  &__component {
    margin-top: 200px;
    @media (max-width: $tablet) {
      margin-top: 20px;
    }
  }
}
.outro {
  background-color: var(--color-cupcake-1);
  text-align: center;
  padding-bottom: 100px;
  &__image {
    width: 50%;
    margin-top: -400px;
    @media (max-width: $tablet) {
      width: 100%;
      margin-top: -200px;
    }
  }
  &__body {
    margin: 40px 0;
  }
  &__title {
    margin: 0 0 40px;
  }
  &__button {
    padding: 8px;
    background-color: var(--color-white-1);
    border: 2px solid var(--color-charcoal-1);
    border-radius: 30px;
    cursor: pointer;
    color: var(--color-charcoal-1);
    margin: 0 auto;
    text-decoration: none;
    display: flex;
    max-width: 200px;
    justify-content: space-evenly;
    align-items: center;
    &--image {
      margin-right: 2px;
    }
    &:hover {
      transform: scale(1.02);
    }
  }
}
.footer {
  text-align: left;
  background-color: var(--color-orange-1);
  margin-top: -50px;
  padding-bottom: 50px;
  @media (max-width: $tablet) {
    text-align: center;
  }
  h2 {
    color: var(--color-white-1);
    padding: 50px 50px 0 50px;
    @media (max-width: $tablet) {
      padding: 40px 20px 0;
    }
  }
  &__contacts {
    color: var(--color-white-1);
    margin: 0 auto;
    padding: 50px;
    align-items: flex-start;
    width: 95%;
    justify-content: space-between;
    display: flex;
    @media (max-width: $tablet) {
      width: auto;
      padding: 10px 0;
      flex-direction: column;
      text-align: center;
      width: 100%;
      align-items: stretch;
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      @media (max-width: $tablet) {
        padding: 10px 0;
      }
      li {
        margin: 0;
        padding: 0;
      }
    }
  }
  img {
    width: 20%;
    @media (max-width: $tablet) {
      width: 90%;
    }
  }
}
</style>